import { render, staticRenderFns } from "./intestinalFlora.vue?vue&type=template&id=38cd1ac2&"
import script from "./intestinalFlora.vue?vue&type=script&lang=js&"
export * from "./intestinalFlora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports